import { FC } from 'react'

import { FeedObjectComment, FeedUserView } from '../../../interfaces'
import Img from '../../Img'
import styles from './AnswerComment.module.css'

interface Props {
  comment: FeedObjectComment
  profile: FeedUserView
}

const AnswerComment: FC<Props> = props => {
  return (
    <div className={styles.wrapper}>
      <Img className={styles.profilePic} height={40} src={props.profile.profilePicUrl} width={40} />
      <div className={styles.comment}>
        <strong>{props.profile.firstName}</strong>
        {props.comment.commentText.value}
      </div>
    </div>
  )
}

export default AnswerComment
